/* eslint @okta/okta-ui/no-specific-methods: 0 */
import Handlebars from 'handlebars';
import _ from './underscore-wrapper';

/**
 * @class module:Okta.internal.util.TemplateUtil
 * @hideconstructor
 */
export default /** @lends module:Okta.internal.util.TemplateUtil */ {
  /**
   * Compiles a Handlebars template
   * @static
   * @method
   */
  // TODO: This will be deprecated at some point. Views should use precompiled templates
  tpl: _.memoize(function (tpl) {
    /* eslint @okta/okta-ui/no-specific-methods: 0 */

    // Handlebars 4.6.x introduced a breaking change with prototype/own values. If a kill-switch
    // is enabled - fallback to prior implementation logic. OKTA-297682
    const runtimeOptions = {};

    if (window && window.__OKTA_HANDLEBARS_FALLBACK__) {
      runtimeOptions.allowProtoPropertiesByDefault = true;
    }

    return function (context) {
      return Handlebars.compile(tpl)(context, runtimeOptions);
    };
  })
};



// WEBPACK FOOTER //
// ./node_modules/@okta/courage/src/util/TemplateUtil.js


// WEBPACK FOOTER //
// webpack:///node_modules/@okta/courage/src/util/TemplateUtil.js